module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("Music is fun")]), _c('button', {
    on: {
      "click": _vm.togglePlay
    }
  }, [_vm._v("Play / Stop")]), _c('button', {
    on: {
      "click": function($event) {
        _vm.instruments++
      }
    }
  }, [_vm._v("Add Instrument")]), _c('label', [_vm._v("BPM: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bpm),
      expression: "bpm",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bpm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bpm = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('label', [_vm._v("Min step resolution:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.res),
      expression: "res",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.res)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.res = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('label', [_vm._v("Global transpose:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.globalTranspose),
      expression: "globalTranspose",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.globalTranspose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalTranspose = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('hr'), _vm._l((_vm.instruments), function(i) {
    return _c('instrument', {
      attrs: {
        "res": _vm.res,
        "time": _vm.time,
        "globalTranspose": _vm.globalTranspose
      }
    })
  }), _c('a', {
    attrs: {
      "href": "https://github.com/bsteephenson/Step-Sequencer"
    }
  }, [_vm._v("Source")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da8dda36!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 21
// module chunks = 1